import { render, staticRenderFns } from "./AssociationImportInterface.vue?vue&type=template&id=01d2ce1d"
import script from "./AssociationImportInterface.vue?vue&type=script&lang=js"
export * from "./AssociationImportInterface.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports